<div style="padding: 18px 20px 8px 20px; min-width: 460px; max-width: 620px;">
  <div class="flex items-center gap-2 mb-3">
    <mat-icon style="color: #1C593D;">add_location_alt</mat-icon>
    <h2 style="font-size: 1rem; font-weight: 800; color: #1e5a3f; margin: 0;">Agregar país al whitelist</h2>
    <button type="button" (click)="close()" class="ml-auto"
      style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border: none; background: transparent; color: #9ca3af; cursor: pointer; border-radius: 6px;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px;">close</mat-icon>
    </button>
  </div>

  <p style="font-size: 0.8rem; color: #6b7280; margin: 0 0 12px 0;">
    Lista live de países que Vita publica ahora mismo y aún no tenés agregados.
    Al seleccionar uno, se agrega a la tabla de países permitidos.
  </p>

  <div style="display: flex; align-items: center; gap: 6px; background: white; border: 1px solid #d1d5db; border-radius: 10px; padding: 6px 12px; margin-bottom: 12px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">search</mat-icon>
    <input type="text" [(ngModel)]="search"
      placeholder="Buscar por nombre, código o moneda…"
      style="flex: 1; border: none; outline: none; font-size: 0.85rem; color: #374151; background: transparent;" />
    <button *ngIf="search" type="button" (click)="search=''"
      style="display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: none; background: transparent; color: #9ca3af; cursor: pointer;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">close</mat-icon>
    </button>
  </div>

  <div *ngIf="loading" class="flex justify-center py-6">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div *ngIf="error" style="display: flex; align-items: center; gap: 8px; background: #fef2f2; padding: 10px 12px; border-radius: 8px; border: 1px solid #fecaca;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">warning</mat-icon>
    <span style="font-size: 0.8rem; font-weight: 600; color: #b91c1c;">{{ error }}</span>
  </div>

  <div *ngIf="!loading && !error && filtered.length === 0"
    style="display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 24px; color: #6b7280;">
    <mat-icon style="font-size: 32px; width: 32px; height: 32px; color: #d1d5db;">search_off</mat-icon>
    <span style="font-size: 0.82rem;">No hay países nuevos disponibles en Vita</span>
  </div>

  <div *ngIf="!loading && !error && filtered.length > 0"
    style="max-height: 400px; overflow-y: auto; border: 1px solid #e5e7eb; border-radius: 10px;">
    <div *ngFor="let c of filtered; let last = last"
      style="display: flex; align-items: center; gap: 10px; padding: 12px; cursor: pointer; transition: background 0.15s;"
      [style.border-bottom]="last ? 'none' : '1px solid #f3f4f6'"
      [style.opacity]="addingCode === c.code ? '0.5' : '1'"
      [style.pointer-events]="addingCode ? 'none' : 'auto'"
      (click)="add(c)"
      onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
      <img [src]="'https://flagcdn.com/24x18/' + c.code.toLowerCase() + '.png'"
        [alt]="c.code" width="24" height="18"
        style="border-radius: 2px; border: 1px solid #e5e7eb; flex-shrink: 0;"
        onerror="this.style.visibility='hidden'" />
      <div style="flex: 1; min-width: 0;">
        <div style="font-size: 0.85rem; font-weight: 700; color: #374151;">{{ c.name }}</div>
        <div style="display: flex; gap: 8px; margin-top: 2px; flex-wrap: wrap;">
          <span style="font-size: 0.7rem; font-family: monospace; font-weight: 700; background: #f3f4f6; color: #1e5a3f; padding: 1px 6px; border-radius: 4px;">{{ c.code }}</span>
          <span style="font-size: 0.7rem; text-transform: uppercase; font-weight: 600; color: #6b7280;">{{ c.currency }}</span>
          <span style="font-size: 0.7rem; color: #6b7280;">·</span>
          <span style="font-size: 0.7rem; color: #4b5563;">
            {{ c.variants.length }} {{ c.variants.length === 1 ? 'método' : 'métodos' }}:
            <span *ngFor="let v of c.variants; let i = index" style="color: #1e5a3f; font-weight: 600;">
              {{ i > 0 ? ', ' : '' }}{{ v.code }}
            </span>
          </span>
        </div>
      </div>
      <mat-spinner *ngIf="addingCode === c.code" diameter="18"></mat-spinner>
      <mat-icon *ngIf="addingCode !== c.code" style="color: #1C593D;">add_circle</mat-icon>
    </div>
  </div>
</div>
